import { render, staticRenderFns } from "./UniqueCheck.vue?vue&type=template&id=635d38fa"
import script from "./UniqueCheck.vue?vue&type=script&lang=js"
export * from "./UniqueCheck.vue?vue&type=script&lang=js"
import style0 from "./UniqueCheck.vue?vue&type=style&index=0&id=635d38fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports